import React from "react"
import { Badge } from "reactstrap"
import { Link } from "react-router-dom"
import {SortIcon} from 'components/Table_SortColumnIcon'
import { getFormattedTime } from "utils"

const domainsListColumn = () => {
  return[
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, domain) => (
        <>
          {domain.id}
        </>
      )
    },
    {
      text: "Domain",
      dataField: "name",
      sort: true,
      sortCaret: (order) => <SortIcon order={order}/>,
      formatter: (cellContent, domain) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {domain.name}
            </Link>
          </h5>
          {/*<p className="text-muted mb-0">{user.designation}</p>*/}
        </>
      )
    },
    {
      text: "Tags",
      dataField: "tags",
      formatter: (cellContent, domain) => (
        <>
          {domain.tags.map((tag, key) => (
            <div key={key}>
              <Badge
                className={"font-size-10 badge-soft-" + "primary"}
                color={"primary"}
                pill
              >
                {tag.tag}{" "}
              </Badge>
            </div>
          ))}
        </>
      )
    },
    {
      text: "Created on",
      dataField: "created_at",
      sort: true,
      sortCaret: (order) => <SortIcon order={order}/>,
      formatter: (cellContent, domain) => {
        return (
          <div className={"font-size-12"}>{getFormattedTime(domain.created_at)}</div>
        )
      }
    }
  ]
}

export default domainsListColumn
